import React, { Component, Fragment } from "react";

const AttributeVsFormParam = (values) => {
  const [attr, formVal] = values;
  return attr !== undefined || attr !== null || attr !== "" ? attr : formVal;
};

const getValidInchVal = (val) => val && val !== "-"; // '-' is to filter out values which have not been entered and the app form is saving '-' instead of empty value

const getFractionInches = (values) => {
  let result = "";
  if (values && Array.isArray(values)) {
    let numbers = values.filter(getValidInchVal);
    if (numbers.length === 1) {
      result = numbers[0];
    } else if (numbers.length === 2) {
      result = (
        <Fragment>
          <span style={{ whiteSpace: "nowrap" }}>
            {numbers[0]} <sup>{numbers[1].split("/")[0]}</sup>⁄<sub>{numbers[1].split("/")[1]}</sub>
          </span>
        </Fragment>
      );
    }
  }
  return result;
};

export const TNW_SwitchInspectionReportSchema = {
  sections: [
    {
      heights: {
        header1: "50px",
        header2: "200px",
      },
      minDataRowsCount: 5,
      columns: [
        {
          title: "MP/YARD",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: "milepost",
        },
        {
          title: "SW. ID.",
          colSpan: 3,

          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "switchName",
        },
        // 1. Remove
        // {
        //   title: "ALIGNMENT",
        //   colSpan: 1,
        //   rowSpan: 2,
        //   className: "tbl-text-rotate",
        //   accessor: "summary.align",
        // },

        // 2. Remove

        // {
        //   title: "SURFACE",
        //   colSpan: 1,
        //   rowSpan: 2,
        //   className: "tbl-text-rotate",
        //   accessor: "summary.surf",
        // },

        // 3. Remove
        // {
        //   title: "CROSSLEVEL",
        //   colSpan: 1,
        //   rowSpan: 2,
        //   className: "tbl-text-rotate",
        //   accessor: "summary.cross",
        // },

        // 4. Rename  MAX GAGE STR. (in.)
        {
          title: "FRONT OF POINTS",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch1", "summary.pinch1"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        // 5. Rename MAX GAGE CLOSURE (in.)
        {
          title: "HEEL BLOCKS (Str)",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch2", "summary.pinch2"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        //6. Rename SWITCH POINT RH (in.)
        {
          title: "HEEL BLOCK TURNOUT",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch3", "summary.pinch3"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        // 7. Rename  SWITCH POINT LH (in.)
        {
          title: "CLOSURE RAIL (Str)",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch4", "summary.pinch4"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        // 8. Rename  HEEL BLOCK (in.)
        {
          title: "CLOSURE RAIL TURNOUT",
          colSpan: 1,
          rowSpan: 2,
          className: "tbl-text-rotate",
          accessor: ["summary.inch5", "summary.pinch5"],
          dontJoinValues: true,
          formatter: getFractionInches,
          dataFontSize: "12px",
        },

        // 9,10,11. Remove
        // {
        //   title: "STOCK RAIL STR (in.)",
        //   colSpan: 1,
        //   rowSpan: 2,
        //   className: "tbl-text-rotate",
        //   accessor: ["summary.inch6", "summary.pinch6"],
        //   dontJoinValues: true,
        //   formatter: getFractionInches,
        //   dataFontSize: "12px",
        // },
        // {
        //   title: "STOCK RAIL BENT (in.)",
        //   colSpan: 1,
        //   rowSpan: 2,
        //   className: "tbl-text-rotate",
        //   accessor: ["summary.inch7", "summary.pinch7"],
        //   dontJoinValues: true,
        //   formatter: getFractionInches,
        //   dataFontSize: "12px",
        // },
        // {
        //   title: "CLOSUE RAIL- T/O SIDE (in.)",
        //   colSpan: 1,
        //   rowSpan: 2,
        //   className: "tbl-text-rotate",
        //   accessor: ["summary.inch8", "summary.pinch8"],
        //   dontJoinValues: true,
        //   formatter: getFractionInches,
        //   dataFontSize: "12px",
        // },

        {
          title: "FROG",
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "FROG #",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["attributes.Frog Number", "summary.frogno"],
              dontJoinValues: true,
              formatter: AttributeVsFormParam,
            },
            {
              title: "TYPE",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["attributes.Frog Type", "summary.ftype"],
              dontJoinValues: true,
              formatter: AttributeVsFormParam,
            },

            {
              title: "WEAR MEASUREMENT",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["summary.inch6", "summary.pinch6"],
              dontJoinValues: true,
              // formatter: AttributeVsFormParam,
              formatter: getFractionInches,
            },
            // 15,16. Remove
            // {
            //   title: "POINT",
            //   colSpan: 1,
            //   rowSpan: 1,
            //   className: "tbl-text-rotate",
            //   accessor: "summary.pin",
            // },
            // {
            //   title: "BOLTS",
            //   colSpan: 1,
            //   rowSpan: 1,
            //   className: "tbl-text-rotate",
            //   accessor: "summary.bolt",
            // },
          ],
        },

        {
          title: "GUARD RAIL",
          colSpan: 5,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "CHECK STR. (in.)",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["summary.inch9", "summary.pinch9"],
              dontJoinValues: true,
              formatter: getFractionInches,
              dataFontSize: "12px",
            },
            {
              title: "CHECK T/O (in.)",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["summary.inch10", "summary.pinch10"],
              dontJoinValues: true,
              formatter: getFractionInches,
              dataFontSize: "12px",
            },
            {
              title: "FACE STR. (in.)",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["summary.inch11", "summary.pinch11"],
              dontJoinValues: true,
              formatter: getFractionInches,
              dataFontSize: "12px",
            },
            {
              title: "FACE T/O (in.)",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["summary.inch13", "summary.pinch13"],
              dontJoinValues: true,
              formatter: getFractionInches,
              dataFontSize: "12px",
            },
            // 34. Add guard rail
            {
              title: "GUARD RAIL LENGTH",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["attributes.Guard Rail length"],
              dontJoinValues: true,
              dataFontSize: "12px",
            },
          ],
        },
        {
          title: "TIE TYPE",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "attributes.Tie Type",
        },
        {
          title: "RAIL SIZE",
          colSpan: 2,
          rowSpan: 2,
          className: "tbl-text-normal",
          accessor: "summary.rsize",
          accessor: ["attributes.Rail Size", "summary.rsize"],
          dontJoinValues: true,
          formatter: AttributeVsFormParam,
        },
        {
          title: "SW PT",
          colSpan: 2,
          rowSpan: 1,
          className: "tbl-text-normal",
          columns: [
            {
              title: "TYPE",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: "summary.swpty",
              accessor: ["attributes.Switch Point Type", "summary.swpty"],
              dontJoinValues: true,
              formatter: AttributeVsFormParam,
            },
            {
              title: "LENGTH (in.)",
              colSpan: 1,
              rowSpan: 1,
              className: "tbl-text-rotate",
              accessor: ["attributes.Switch Point Length","summary.swptlen"],
              formatter: (val) => (getValidInchVal(val) ? val : ""),
            },
          ],
        },

        // 34. Add switch point length
        // {
        //   title: "SWITCH POINT LENGTH",
        //   colSpan: 1,
        //   rowSpan: 2,
        //   className: "tbl-text-rotate",
         
        //   accessor: ["attributes.Switch Point Length"],
        //   dontJoinValues: true,
        //   formatter: AttributeVsFormParam,
        // },
      ],
    },
    {
      heights: {
        header1: "60px",
      },
      minDataRowsCount: 5,
      columns: [
        {
          title: "",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-rotate",
          accessor: "milepost",
        },
        {
          title: "SW. ID.",
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "switchName",
        },
        {
          title: "T.O. SIDE",
          colSpan: 2,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.toside",
          dataFontSize: "13px",
          accessor: ["attributes.Turnout Side", "summary.toside"],
          dontJoinValues: true,
          formatter: AttributeVsFormParam,
        },
        {
          title: "SW STAND TYPE",
          colSpan: 4,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.swsta",
          accessor: ["attributes.Switch Stand Type", "summary.swsta"],
          dontJoinValues: true,
          formatter: AttributeVsFormParam,
        },
        {
          title: "SW OPERATOR",
          colSpan: 4,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.swoper",
          accessor: ["attributes.Switch Operator", "summary.swsta"],
          dontJoinValues: true,
          formatter: AttributeVsFormParam,
        },

        // 29,30,31. Remove

        // {
        //   title: "OTM (BRACES / PLATES / RODS)",
        //   colSpan: 4,
        //   rowSpan: 1,
        //   className: "tbl-text-normal",
        //   accessor: "summary.otm",
        // },
        // {
        //   title: "SWITCH STAND",
        //   colSpan: 4,
        //   rowSpan: 1,
        //   className: "tbl-text-normal",
        //   accessor: "summary.sstan",
        // },
        // {
        //   title: "QUANTITY TIES NEEDED",
        //   colSpan: 2,
        //   rowSpan: 1,
        //   className: "tbl-text-normal",
        //   accessor: "summary.tcond",
        // },
        {
          title: "COMMENTS",
          colSpan: 9,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "summary.comm",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/TNW/SwitchInspectionReport/TNW_SwitchInspectionReportSchema.js